module.exports = __webpack_public_path__ + "media/bell.82948dc9.mp4";